import { render } from "./BankTxnsEditModalPopup.vue?vue&type=template&id=eb89c80a&scoped=true"
import script from "./BankTxnsEditModalPopup.vue?vue&type=script&lang=js"
export * from "./BankTxnsEditModalPopup.vue?vue&type=script&lang=js"

import "./BankTxnsEditModalPopup.vue?vue&type=style&index=0&id=eb89c80a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb89c80a"]])

export default __exports__